import { getCategoryBySlug, getCategories } from "@/lib/api/categories";

export function normalizeCategoriesList(response) {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  return response?.data?.data || [];
}

/**
 * Resolve a category by slug, id, or title_en with list fallback.
 * @param {string} slug
 * @param {Array|null} [preloadedCategories]
 */
export async function resolveCategoryBySlug(slug, preloadedCategories = null) {
  if (!slug) return null;

  const direct = await getCategoryBySlug(slug).catch(() => null);
  if (direct) {
    const category = direct.category || direct;
    if (category?.id || category?.title_en || category?.UUID) {
      return category;
    }
  }

  const categories =
    preloadedCategories ??
    normalizeCategoriesList(await getCategories().catch(() => []));

  return (
    categories.find(
      (category) =>
        category.title_en === slug ||
        category.slug === slug ||
        String(category.id) === String(slug) ||
        category.UUID === slug
    ) || null
  );
}

/** @returns {string|null} Primary DB id for admin mutations (UUID). */
export function getCategoryRecordId(category) {
  const id = category?.id ?? category?.UUID;
  return id != null && String(id).trim() ? String(id) : null;
}

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isCategoryUuid(value) {
  return typeof value === "string" && UUID_RE.test(value);
}

/** Prefer API slug used for product filtering. */
export function getCategoryFilterSlug(category, fallbackSlug) {
  return category?.title_en || category?.slug || fallbackSlug;
}
